import { createAuthenticationService } from '@perpay-web/authentication/createAuthenticationService';

export const authentication = createAuthenticationService();
